"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectRestaurantView = void 0;
const React = require("react");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const useRequiredContext_1 = require("../../../../../hooks/useRequiredContext");
const context_1 = require("../../handlers/CustomerLocationHandler/context");
const AppScreen_1 = require("../../../../../components/base/atoms/AppScreen");
const RetailLocationsContext_1 = require("../../contexts/RetailLocationsContext");
const SalesOrderContext_1 = require("../../contexts/SalesOrderContext");
const useSortedRetailLocationsByDistance_1 = require("../../hooks/useSortedRetailLocationsByDistance");
const retailOrderingRoutes_1 = require("../../../../../apps/spg/ordering/components/RetailOrderingApp/retailOrderingRoutes");
const Loader_1 = require("../../../../../components/base/atoms/Loader");
const PendingCustomerSalesOrders_1 = require("../../atoms/PendingCustomerSalesOrders");
const SplitView_1 = require("../../../../../components/base/structure/SplitView");
const useConfig_1 = require("../../../../../hooks/useConfig");
const MarketingCarousel_1 = require("../../atoms/MarketingCarousel");
const SelectRestaurantList_1 = require("../../atoms/SelectRestaurantList");
const useCheckRestaurantServiceAvailability_1 = require("../../hooks/useCheckRestaurantServiceAvailability");
const ServiceUnavailableModal_1 = require("../../modals/ServiceUnavailableModal");
const MobileRestaurantsMap_1 = require("./MobileRestaurantsMap");
const OrderDetailsPanel_1 = require("./OrderDetailsPanel");
const MobileViewOptions_1 = require("./MobileViewOptions");
const OrderTypeContext_1 = require("../../contexts/OrderTypeContext");
const ConfirmSetLocationModal_1 = require("../../modals/ConfirmSetLocationModal");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "SelectRestaurantView");
const SelectRestaurantView = ({}) => {
    const history = (0, react_router_dom_1.useHistory)();
    const { locationMaxRange } = (0, useConfig_1.useConfig)();
    const { customerLocation, setCustomerLocation } = (0, useRequiredContext_1.useRequiredContext)(context_1.CustomerLocationContext);
    const { setRetailLocation, retailLocation, requestedRetailLocationSlug, retailLocations } = (0, useRequiredContext_1.useRequiredContext)(RetailLocationsContext_1.RetailLocationsContext);
    const { temporarySalesOrderId, isPerformingCartRecovery, requestedReadyTime, setTemporaryAddress } = (0, useRequiredContext_1.useRequiredContext)(SalesOrderContext_1.SalesOrderContext);
    const { orderType } = (0, useRequiredContext_1.useRequiredContext)(OrderTypeContext_1.OrderTypeContext);
    const [serviceUnavailableMsg, setServiceUnavailableMsg] = (0, react_1.useState)(null);
    const [showConfirmSetLocationModal, setShowConfirmSetLocationModal] = (0, react_1.useState)(null);
    const [viewOption, setViewOption] = (0, react_1.useState)(0);
    const [checkingRestaurantServiceAvailability, setCheckingRestaurantServiceAvailability] = (0, react_1.useState)(false);
    const nearestStores = (0, useSortedRetailLocationsByDistance_1.useSortedRetailLocationsByDistance)({
        locationMaxRange,
        operatingOnly: true
    });
    const checkRestaurantServiceAvailability = (0, useCheckRestaurantServiceAvailability_1.useCheckRestaurantServiceAvailability)();
    const checkRestaurantServiceAvailabilityFn = (0, react_1.useCallback)(async (restaurant) => {
        if (!customerLocation) {
            setShowConfirmSetLocationModal(true);
            return;
        }
        const serviceAvailable = await checkRestaurantServiceAvailability(restaurant, orderType, customerLocation, requestedReadyTime, setServiceUnavailableMsg, setCheckingRestaurantServiceAvailability);
        if (!serviceAvailable) {
            return;
        }
        setTemporaryAddress(customerLocation);
        history.push(retailOrderingRoutes_1.retailOrderingPaths.menu, history.location.pathname);
    }, [orderType, customerLocation, requestedReadyTime]);
    (0, react_1.useEffect)(() => {
        if (isPerformingCartRecovery && temporarySalesOrderId) {
            history.push(retailOrderingRoutes_1.retailOrderingPaths.menu, history.location.pathname);
        }
    }, [isPerformingCartRecovery, temporarySalesOrderId]);
    const restaurants = (0, react_1.useMemo)(() => {
        if (!retailLocations) {
            return null;
        }
        if (requestedRetailLocationSlug) {
            return retailLocations.filter(retailLocation => retailLocation.slug === requestedRetailLocationSlug);
        }
        if (retailLocation) {
            const retailLocationExists = nearestStores.some(nearestStore => nearestStore.retailLocationId === retailLocation.retailLocationId);
            if (!retailLocationExists) {
                setRetailLocation(null);
            }
        }
        return nearestStores;
    }, [requestedRetailLocationSlug, nearestStores]);
    (0, react_1.useEffect)(() => {
        if (!restaurants) {
            return;
        }
        if (restaurants.length === 1) {
            setRetailLocation(restaurants[0]);
        }
    }, [restaurants]);
    return (React.createElement("div", { className: css("") },
        React.createElement(Loader_1.LoadingOverlay, { className: css("loader"), visible: !Array.isArray(restaurants) || checkingRestaurantServiceAvailability, text: checkingRestaurantServiceAvailability
                ? "checking service availability"
                : "finding stores near you" },
            React.createElement(AppScreen_1.AppScreen, null,
                React.createElement(PendingCustomerSalesOrders_1.PendingCustomerSalesOrders, { className: css("pendingOrders") }),
                React.createElement(AppScreen_1.AppScreenBody, { className: css("appScreenBody") },
                    React.createElement("div", { className: css("orderOptionsBg") }),
                    React.createElement(SplitView_1.SplitView, { className: css("splitView") },
                        React.createElement(SplitView_1.DetailsView, { sticky: true, size: "lg" },
                            React.createElement(OrderDetailsPanel_1.OrderDetailsPanel, { customerLocation: customerLocation, setCustomerLocation: setCustomerLocation, restaurants: restaurants, selectRestaurant: checkRestaurantServiceAvailabilityFn }),
                            React.createElement(MobileViewOptions_1.MobileViewOptions, { viewOption: viewOption, setViewOption: setViewOption })),
                        React.createElement(SplitView_1.ContentView, { className: css("contentView") }, viewOption === 0 ? (React.createElement("div", { id: "scroller", className: css("scroller") },
                            React.createElement(MarketingCarousel_1.MarketingCarousel, null),
                            React.createElement(SelectRestaurantList_1.SelectRestaurantList, { restaurants: restaurants, currentOrderType: orderType, selectRestaurant: checkRestaurantServiceAvailabilityFn }))) : (React.createElement(MobileRestaurantsMap_1.MobileRestaurantsMap, { restaurants: restaurants, viewOption: viewOption, setViewOption: setViewOption, selectRestaurant: checkRestaurantServiceAvailabilityFn, currentOrderType: orderType }))))))),
        React.createElement(ServiceUnavailableModal_1.ServiceUnavailableModal, { serviceUnavailableMsg: serviceUnavailableMsg, setServiceUnavailableMsg: setServiceUnavailableMsg }),
        React.createElement(ConfirmSetLocationModal_1.ConfirmSetLocationModal, { open: showConfirmSetLocationModal, setOpen: setShowConfirmSetLocationModal })));
};
exports.SelectRestaurantView = SelectRestaurantView;
//# sourceMappingURL=index.js.map